import { Select } from "antd"
import ArrowBackButton from "../../../../components/button/ArrowBackButton"
import useUserForm from "./useUserForm"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"
import Loading from "../../../../components/loading/Loading"

const UserForm = () => {
    const param = useParams()
    const [isUpdate, setUpdate] = useState(false)
    const [businessUnitError, setBusinessUnitError] = useState(false)
    const {
        setListBu,
        businessUnits,
        setListRoles,
        roles,
        postUserForm,
        putUserForm,
        getUserForm,
        payload,
        onChangeHandler,
        handleSelectBusinessUnit,
        handleSelectRole,
        scoringMethod,
        handleSelectScoringMethod,
        allUsers,
        userValue,
        getAllUsers,
        handleSelectedSupervisor,
        isLoadingUser
    } = useUserForm()

    useEffect(() => {
        setListBu()
        setListRoles()
        getAllUsers()
        if (param.user_id) {
            setUpdate(true)
            getUserForm(param.user_id)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (param.user_id) {
            getUserForm(param.user_id)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userValue])

    const isFormDisabled = isUpdate && isLoadingUser

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton title={isUpdate ? "Update User" : "Create User"} isTwoSection={true}/>
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <Loading state={isFormDisabled} />
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '18px'
                }}>
                    User Information
                </h5>

                <form
                    style={{ opacity: isFormDisabled ? 0.6 : 1, pointerEvents: isFormDisabled ? 'none' : 'auto' }}
                    onSubmit={(e) => {
                    e.preventDefault()
                    if (!payload.BusinessUnitId) {
                        setBusinessUnitError(true)
                        return
                    }
                    setBusinessUnitError(false)
                    isUpdate ? putUserForm(e) : postUserForm(e)
                }}>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="UserEmail" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Email <span style={{color: 'red'}}>*</span> <span style={{color: '#6b7280', fontWeight: '400', fontSize: '12px'}}>(required as calibrator)</span>
                                </label>
                                <input 
                                    type="email" 
                                    name="Email"
                                    className="form-control" 
                                    id="Email" 
                                    placeholder="Enter Email" 
                                    onChange={onChangeHandler}
                                    value={payload.Email}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="EmployeeName" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Name <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="text" 
                                    name="Name"
                                    className="form-control" 
                                    id="Name" 
                                    placeholder="Enter Employee Name" 
                                    onChange={onChangeHandler}
                                    value={payload.Name}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: !payload.Name ? '1px solid #ff4d4f' : '1px solid #d1d5db'
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="Nik" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    NIK <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="number" 
                                    name="Nik"
                                    className="form-control" 
                                    id="Nik" 
                                    placeholder="Enter Employee NIK" 
                                    onChange={onChangeHandler}
                                    value={payload.Nik}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: !payload.Nik ? '1px solid #ff4d4f' : '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="DateOfBirth" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Date of Birth
                                </label>
                                <input 
                                    type="date" 
                                    name="DateOfBirth"
                                    className="form-control" 
                                    id="DateOfBirth" 
                                    placeholder="Enter Employee Date of Birth" 
                                    onChange={onChangeHandler}
                                    value={payload.DateOfBirth}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="Supervisor" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Supervisor
                                </label>
                                <Select
                                    showSearch={true}
                                    allowClear
                                    size="large"
                                    style={{
                                        width: '100%'
                                    }}
                                    name="Supervisor"
                                    options={allUsers}
                                    placeholder="Enter Employee"
                                    onChange={handleSelectedSupervisor}
                                    value={payload.SupervisorNik}
                                    fontSize="16px"
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="BusinessUnit" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Business Unit <span style={{color: 'red'}}>*</span>
                                </label>
                                <Select
                                    showSearch
                                    allowClear
                                    size="large"
                                    style={{
                                        width: '100%'
                                    }}
                                    name="Business Unit"
                                    options={businessUnits}
                                    placeholder="Enter Business Unit"
                                    onChange={(val) => {
                                        setBusinessUnitError(false)
                                        handleSelectBusinessUnit(val)
                                    }}
                                    value={payload.BusinessUnitId}
                                    status={businessUnitError || !payload.BusinessUnitId ? 'error' : ''}
                                    fontSize="16px"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                                {businessUnitError && !payload.BusinessUnitId && (
                                    <div style={{ color: '#ff4d4f', fontSize: '12px', marginTop: '6px' }}>
                                        Business Unit is required.
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="OrganizationUnit" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Org. Unit
                                </label>
                                <input 
                                    type="text" 
                                    name="OrganizationUnit"
                                    className="form-control" 
                                    id="OrganizationUnit" 
                                    placeholder="Enter Employee Org. Unit" 
                                    onChange={onChangeHandler}
                                    value={payload.OrganizationUnit}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="Position" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Position
                                </label>
                                <input 
                                    type="text" 
                                    name="Position"
                                    className="form-control" 
                                    id="Position" 
                                    placeholder="Enter Employee Position" 
                                    onChange={onChangeHandler}
                                    value={payload.Position}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="Division" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Division
                                </label>
                                <input 
                                    type="text" 
                                    name="Division"
                                    className="form-control" 
                                    id="Division" 
                                    placeholder="Enter Employee Division" 
                                    onChange={onChangeHandler}
                                    value={payload.Division}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="Department" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Department
                                </label>
                                <input 
                                    type="text" 
                                    name="Department"
                                    className="form-control" 
                                    id="Department" 
                                    placeholder="Enter Employee Department" 
                                    onChange={onChangeHandler}
                                    value={payload.Department}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="JoinDate" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Join Date
                                </label>
                                <input 
                                    type="date" 
                                    name="JoinDate"
                                    className="form-control" 
                                    id="JoinDate" 
                                    placeholder="Enter Employee Join Date" 
                                    onChange={onChangeHandler}
                                    value={payload.JoinDate}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="Grade" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Grade
                                </label>
                                <input 
                                    type="text" 
                                    name="Grade"
                                    className="form-control" 
                                    id="Grade" 
                                    placeholder="Enter Employee Grade" 
                                    onChange={onChangeHandler}
                                    value={payload.Grade}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="PhoneNumber" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Phone Number
                                </label>
                                <input 
                                    type="text" 
                                    name="PhoneNumber"
                                    className="form-control" 
                                    id="Phone Number" 
                                    placeholder="Enter Employee Phone Number Start With 62" 
                                    onChange={onChangeHandler}
                                    value={payload.PhoneNumber}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="Role" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Role
                                </label>
                                <Select
                                    allowClear
                                    size="large"
                                    style={{
                                        width: '100%',
                                        height: '46px'
                                    }}
                                    mode="multiple"
                                    name="roles"
                                    options={roles}
                                    placeholder="Enter Role"
                                    onChange={handleSelectRole}
                                    value={payload.Roles}
                                    fontSize="16px"
                                />
                            </div>
                        </div>

                        <div className="flex-row" style={{flexWrap: 'wrap', gap: '16px'}}>
                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="ScoringMethod" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Scoring Method
                                </label>
                                <Select
                                    allowClear
                                    size="large"
                                    style={{
                                        width: '100%',
                                        height: '46px'
                                    }}
                                    name="Business Unit"
                                    options={scoringMethod}
                                    placeholder="Enter Scoring Method"
                                    onChange={handleSelectScoringMethod}
                                    value={payload.ScoringMethod}
                                    fontSize="16px"
                                />
                            </div>

                            <div className="mb-4" style={{width: 'calc(50% - 8px)'}}>
                                <label htmlFor="AdditionalInfo" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Additional Information
                                </label>
                                <input 
                                    type="text" 
                                    name="AdditionalInfo"
                                    className="form-control" 
                                    id={`additional-info`} 
                                    placeholder="Enter Additional Information" 
                                    value={payload.AdditionalInfo}
                                    onChange={onChangeHandler}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        { isUpdate ? 
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                children={"Save Changes"}
                                disabled={isFormDisabled}
                            />
                            :
                            <ActionButtonGradient
                                type="submit"
                                variant="success"
                                children={"Save User"}
                                disabled={isFormDisabled}
                            />
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default UserForm